import { create } from 'zustand';

import { api } from '@/api/client.ts';

export interface CurrentUser {
  id: string;
  name: string;
  role: 'STUDENT' | 'TEACHER' | 'ADMIN';
  account: string;
  email?: string | null;
  grade?: string | null;
  avatar?: string | null;
}

interface AuthState {
  user: CurrentUser | null;
  setUser: (user: CurrentUser | null) => void;
  clear: () => void;
  hydrate: () => Promise<void>;
}

// JWT lives in an httpOnly cookie (ADR-004); zustand only mirrors the user
// profile so the shells can render name / role without re-fetching /me.
export const useAuth = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clear: () => set({ user: null }),
  // main.tsx awaits this before first render, so route guards always read a
  // settled user (non-null or null) and never redirect on a transient state.
  hydrate: async () => {
    try {
      const res = await api<{ user: CurrentUser }>('/api/auth/me');
      set({ user: res.user });
    } catch {
      set({ user: null });
    }
  },
}));
